import React from "react";
import { Checkbox, FormControlLabel, FormGroup, Typography } from "@mui/material";

function CheckboxGroup({ isMobileDisplay, checkboxes = [], checkboxFilters, setCheckboxFilters }) {
  const handleCheckboxFiltersChanged = (event) => {
    const newFilters = { ...checkboxFilters };
    newFilters[event.target.value] = event.target.checked;
    setCheckboxFilters(newFilters);
  };

  return checkboxes?.length ? (
    <FormGroup aria-label="position" sx={{ flexDirection: isMobileDisplay ? "column" : "row" }}>
      {checkboxes.map((checkbox) => (
        <FormControlLabel
          key={checkbox.value}
          control={
            <Checkbox
              value={checkbox.value}
              checked={checkboxFilters[checkbox.value]}
              onChange={handleCheckboxFiltersChanged}
            />
          }
          label={<Typography sx={{ fontSize: "0.85rem" }}>{checkbox.label}</Typography>}
          sx={{ display: "flex" }}
        />
      ))}
    </FormGroup>
  ) : null;
}

export default CheckboxGroup;
